import { constants } from '../constant/constant';
import { httpservice } from '../services';
import { dateFormat } from '../helper/StringUtils';
import { CLOUD_CLIENT } from '../constant/actionTypes';

export const getCloudClientList = () => (dispatch) => {
  const query = `${constants.API.CLOUD_CLIENTS}`;

  dispatch({
    payload: [],
    type: CLOUD_CLIENT.GET.INITIATE,
  });

  return httpservice()
    .get(query)
    .then((response) => {
      let rows = [];
      let count = 0;
      if (response.data.response.length) {
        rows = response.data.response;
        count = response.data.response.length;
      } else {
        rows = response.data.response.rows;
        count = response.data.response.count;
      }

      const responseData = rows && rows.length ? rows.map((data) => ({
        ...data,
        createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
        created_at: dateFormat(data.createdAt),
        apiKeyValidity: dateFormat(data.apiKeyValidity),
      })) : [];

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: CLOUD_CLIENT.GET.SUCCESS,
      });

      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: CLOUD_CLIENT.GET.ERROR,
      });
    });
};

export const doCreateCloudClient = (clientInfo) => httpservice()
  .post(`${constants.API.CLOUD_CLIENTS}`, clientInfo)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doCheckCloudClient = (clientInfo) => httpservice()
  .post(`${constants.API.CLOUD_CLIENT_CHECK}`, clientInfo)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doUpdateCloudClient = (clientInfo) => httpservice()
  .put(`${constants.API.CLOUD_CLIENTS}/${clientInfo.id}`, clientInfo)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doDeleteCloudClient = (clientInfo) => httpservice()
  .delete(`${constants.API.CLOUD_CLIENTS}/${clientInfo}`)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const getCloudClientSoftwares = (object) => (dispatch) => {
  const url = `${constants.API.CLOUD_CLIENT_SOFTWARE_SUBMODULE}/${object.id}`;

  dispatch({
    payload: [],
    type: CLOUD_CLIENT.SOFTWARES_LIST.INITIATE,
  });

  return httpservice()
    .get(url)
    .then((response) => {
      let rows = [];
      let count = 0;
      if (response.data.response.length) {
        rows = response.data.response;
        count = response.data.response.length;
      } else {
        rows = response.data.response.rows;
        count = response.data.response.count;
      }

      const responseData = rows && rows.length ? rows.map((data) => {
        const { software, ...rest } = data;
        return {
          ...rest,
          name: software.name,
          code: software.code,
          guid: software.guid,
          created_at: dateFormat(data.createdAt),
          last_login: (data.lastLogin) ? dateFormat(data.lastLogin) : '-',
        };
      }) : [];

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: CLOUD_CLIENT.SOFTWARES_LIST.SUCCESS,
      });
      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: CLOUD_CLIENT.SOFTWARES_LIST.ERROR,
      });
    });
};
